import { EmptyCell, Typography, Icon } from 'shared/ui'
import { type IColumn } from 'shared/ui/TableNew'
import { uiStore } from 'shared/store/uiStore'
import { DayjsFormats } from 'shared/lib'
import { EnumUserRoles } from 'entities/Users'
import { type RowInvite } from 'entities/Users/model/Table/RowInvite'
import { RoleChip } from 'pages/settings/pages/members/ui/RoleChip/RoleChip'
import styles from './styles.module.scss'

export const getPendingMembersColumns = (): IColumn<RowInvite>[] => [
  {
    field: 'email',
    name: 'Email',
    isDisabledChangeVisible: true,
    maxWidth: '282px',
    renderRowCell: (row) => (
      <div className={styles.email}>
        <Icon
          fontSize={16}
          icon='personFilled'
          className={styles.inviteIcon}
          insideBox
          tertiary
          boxRounded
        />
        <Typography
          variant='body-md-regular'
          ariaLabel='InviteEmail'
          tooltipProps={{
            label: row.email,
          }}
          ellipsis
        >
          {row.email}
        </Typography>
      </div>
    ),
  },
  {
    field: 'roleLabel',
    name: 'Role',
    isDisabledChangeVisible: true,
    maxWidth: '120px',
    renderRowCell: (row) =>
      row.roleLabel ? <RoleChip roleLabel={row.roleLabel} /> : <EmptyCell />,
  },
  {
    field: 'seat',
    name: 'Seat',
    minWidth: '60px',
    renderRowCell: (row) =>
      row.role !== EnumUserRoles.VIEW_ONLY ? (
        <Icon icon='check1' color='var(--content-brand-primary)' />
      ) : (
        <EmptyCell />
      ),
  },
  {
    field: 'createdAt',
    name: 'Invitation date',
    maxWidth: '150px',
    renderRowCell: (row) =>
      row.createdAt && uiStore.dayjs(row.createdAt).format(DayjsFormats.full6),
  },
]
